/** Booking API main value is ``event``. Legacy clients still send ``events``. */
export function normalizeServiceCode(value) {
    const code = String(value || '').trim().toLowerCase()
    return code === 'events' ? 'event' : code
}

export function isEventService(value) {
    return normalizeServiceCode(value) === 'event'
}
